// extracted by mini-css-extract-plugin
export var searchHeader = "_60-0";
export var searchHeaderDark = "_60-1";